export function Sort({ sortVal, sortOrder, setSortVal, setSortOrder, setPage }) {

  function handleChange(e) {

    const value = e.target.value;

    const [field, order] = value.split('|');

    setPage(1);
    setSortVal(field);
    setSortOrder(order);
  }

  return (
    <div className="bill-sort">

      <label htmlFor="sort-select">Sort by: </label>

      <select
        id="sort-select"
        value={`${sortVal}|${sortOrder}`}
        onChange={handleChange}
      >
        <option value="billIntroducedTimeStamp|desc">
          Newest First
        </option>

        <option value="billIntroducedTimeStamp|asc">
          Oldest First
        </option>

        {/* <option value="billCongressNumber|desc">
          Congress (High → Low)
        </option>

        <option value="billCongressNumber|asc">
          Congress (Low → High)
        </option> */}

        <option value="billTitle|asc">
          Title (A → Z)
        </option>

        <option value="billTitle|desc">
          Title (Z → A)
        </option>

      </select>
    </div>
  );
}
